// RBAC + Arabic labels — mirrors backend/adminc/deps.py
export const ROLE_AR = {
  super_admin: "مدير أعلى",
  admin: "مدير",
  content_manager: "مشرف محتوى",
  reports_viewer: "مراقب تقارير",
  dept_manager: "مدير إدارة",
  employee: "موظف",
};

export const PERMS = {
  super_admin: ["*"],
  admin: ["view_admin", "manage_users", "manage_content", "manage_points", "view_reports",
          "export_reports", "view_audit", "manage_settings", "manage_pulse", "cheer_pulse",
          "view_dept", "view_dept_reports", "export_dept_reports"],
  content_manager: ["view_admin", "manage_content"],
  reports_viewer: ["view_admin", "view_reports", "export_reports"],
  dept_manager: ["view_dept", "manage_dept_users", "view_dept_reports", "export_dept_reports",
                 "motivate_dept", "suggest_pulse", "cheer_pulse"],
  employee: [],
};

export const can = (user, perm) => {
  const p = PERMS[user?.role] || [];
  return p.includes("*") || p.includes(perm);
};

export const isAdminUser = (user) => can(user, "view_admin");
export const isDeptManager = (user) => user?.role === "dept_manager";

export const TYPE_AR = { field: "موظف ميداني", office: "موظف مكتبي", manager: "مدير إدارة" };
export const APPROVAL_AR = {
  onboarding: "لم يكمل الإعداد", pending: "قيد المراجعة", approved: "معتمد",
  rejected: "مرفوض", suspended: "معلّق",
};
export const APPROVAL_TONE = {
  onboarding: "muted", pending: "gold", approved: "emerald", rejected: "red", suspended: "red",
};

export const PULSE_KIND_AR = {  challenge: "إكمال تحدٍ", badge: "شارة جديدة", level: "مستوى جديد", streak: "سلسلة تعلّم",
  points: "إنجاز نقاط", rank: "تقدّم في المتصدرين", department: "إنجاز إدارة",
  platform: "إنجاز عام للمنصة", new_challenge: "تحدٍ جديد", manual: "رسالة تحفيزية",
};
export const NAME_POLICY_AR = {
  full: "الاسم الكامل", first: "الاسم الأول فقط",
  first_initial: "الاسم الأول + أول حرف من العائلة", anonymous: "إخفاء الاسم",
};

export const CH_STATUS_AR = {
  draft: "مسودة", active: "مفعّل", scheduled: "مجدول", locked: "مقفل",
  disabled: "موقوف", archived: "مؤرشف",
};
export const CH_STATUS_TONE = {
  draft: "muted", active: "emerald", scheduled: "gold", locked: "gold", disabled: "red", archived: "muted",
};
export const VIDEO_STATUS_AR = { active: "مفعّل", disabled: "موقوف", locked: "مقفل", scheduled: "مجدول" };
export const Q_TYPE_AR = {
  mcq: "اختيار من متعدد", multi: "متعدد الاختيارات", truefalse: "صح أو خطأ",
  text: "إجابة نصية قصيرة", task: "إجابة نصية طويلة", scenario: "سؤال موقف", ordering: "ترتيب عناصر",
  matching: "توصيل العناصر", hotspot: "اكتشف الخطأ في الصورة", formula_fix: "صحّح الصيغة أو الكود",
};
